(function($) {
	
	$('.menu .menu-item.cta > a').each((index, el)=>{

		const $el = $(el);
		const classString = $el.parent().attr('class');
		const classes = classString.split(' ');
		classes.forEach((className)=>{
			if(className.indexOf('btn')){
				$el.addClass(className);
			}
		});

	});

	$('.btn').each(function(index, el) {

		if(el.classList.length === 1){
			el.classList.add('rose-border'); // by default add those.
			el.classList.add('white-bg');
		}

	});
	
	$('.btn-disabled').on('click', function(event){
		event.preventDefault();
		event.stopPropagation();
		return false;
	})


})(jQuery);